import { quoteQuery } from "@common/api/quoting/quote"
import { useSuspenseQuery } from "@tanstack/react-query"
import { createFileRoute, Navigate } from "@tanstack/react-router"
import { SentPane } from "./-components/send-pane"
import { lastSent } from "./-lib/review-flow"

export const Route = createFileRoute("/_layout/quotes_/$quoteId/sent")({
  component: SentPaneRoute,
})

function SentPaneRoute(): React.ReactElement {
  const { quoteId } = Route.useParams()
  const { data: quote } = useSuspenseQuery(quoteQuery({ quote_id: quoteId }))
  const sent = lastSent(quote)

  if (!sent) {
    return (
      <Navigate
        from={Route.fullPath}
        to="/quotes/$quoteId"
        params={{ quoteId }}
        search={(previous) => ({ ...previous, preview: undefined })}
        replace
      />
    )
  }

  return <SentPane quote={quote} sent={sent} />
}
